import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../homeView.vue";

const route = [
  {
    path: "/",
    component: HomeView
  }
]
const router = createRouter({
    history: createWebHistory(),
    routes: route
})

export default router